import { render, staticRenderFns } from "./Ellipsis.vue?vue&type=template&id=137a5cf2&scoped=true&"
import script from "./Ellipsis.vue?vue&type=script&lang=js&"
export * from "./Ellipsis.vue?vue&type=script&lang=js&"
import style0 from "./Ellipsis.vue?vue&type=style&index=0&id=137a5cf2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137a5cf2",
  null
  
)

export default component.exports